import {
  Component,
  inject,
  Input,
  OnChanges,
  ViewEncapsulation,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-svg-icon',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  template: `<span class="app-svg-icon" [innerHTML]="content"></span>`,
  styles: [
    `
      .app-svg-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
      }
      .app-svg-icon svg {
        width: 1em;
        height: 1em;
        display: block;
      }
    `,
  ],
})
export class SvgIconComponent implements OnChanges {
  @Input({ required: true }) name!: string;
  content?: SafeHtml;

  private static cache = new Map<string, string>();
  private readonly sanitizer = inject(DomSanitizer);

  async ngOnChanges() {
    const name = this.name;
    let svg = SvgIconComponent.cache.get(name);
    if (!svg) {
      const res = await fetch(`assets/images/${name}.svg`);
      svg = await res.text();
      SvgIconComponent.cache.set(name, svg);
    }
    this.content = this.sanitizer.bypassSecurityTrustHtml(svg);
  }
}
